module.exports = __webpack_public_path__ + "img/avatar.9fcde754.png";